{
  "sectionId": "authorizations",
  "header": "Authorizations",
  "available_actions": null,
  "attributes": [
    {
      "attribute_ID": "consumerFirstName",
      "fieldName": "consumerFirstName",
      "label": "First Name",
      "type": "input",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please enter Participant first name",
      "isAvailable": "Y",
      "placeholder": "Participant first name"
    },
    {
      "attribute_ID": "consumerLastName",
      "fieldName": "consumerLastName",
      "label": "Last Name",
      "type": "input",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please enter Participant Last Name",
      "isAvailable": "Y",
      "placeholder": "Participant last name"
    },
    {
      "attribute_ID": "medicaid",
      "fieldName": "medicaid",
      "label": "UCI ID",
      "type": "input",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please enter your UCI Id #",
      "isAvailable": "Y",
      "placeholder": "UCI ID"
    },
    {
      "attribute_ID": "consumerPPLId",
      "fieldName": "consumerPPLId",
      "label": "PPL ID",
      "type": "select",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please enter PPl Id",
      "isAvailable": "Y",
      "placeholder": "Participant PPL Id"
    },
    {
      "attribute_ID": "clientAuth",
      "fieldName": "clientAuth",
      "label": "Spending Plan",
      "type": "input",
      "mandatory": "Y",
      "validator": null,
      "tooltip": "Please enter Spending Plan",
      "placeholder": "Spending Plan",
      "isAvailable": "Y"
    },
    {
      "attribute_ID": "serviceCode",
      "fieldName": "serviceCode",
      "label": "Service Code",
      "type": "input",
      "mandatory": "Y",
      "validator": null,
      "tooltip": "Please select a service code.",
      "isAvailable": "Y"
    },
    {
      "attribute_ID": "authFrequencyLkp",
      "fieldName": "authFrequencyLkp",
      "label": "Authorization Frequency Type",
      "type": "select",
      "mandatory": "Y",
      "validator": null,
      "tooltip": "Please select the authorization frequency type.",
      "isAvailable": "N",
      "placeholder": "Select Authorization Frequency Type"
    },
    {
      "attribute_ID": "carryoverUnits",
      "fieldName": "carryoverUnits",
      "label": "Carry Forward Allowed",
      "type": "radio",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please select if carry forward is allowed",
      "isAvailable": "N",
      "placeholder": "Select"
    },
    {
      "attribute_ID": "dailyHours",
      "fieldName": "dailyHours",
      "label": "Daily hours",
      "type": "input",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please enter daily hours",
      "isAvailable": "Y"
    },
    {
      "attribute_ID": "sunHrs",
      "fieldName": "sunHrs",
      "label": "Sun",
      "type": "input",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please enter hours for Sunday",
      "isAvailable": "Y",
      "placeholder": "Sunday"
    },
    {
      "attribute_ID": "monHrs",
      "fieldName": "monHrs",
      "label": "Mon",
      "type": "input",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please enter hours for Monday",
      "isAvailable": "Y",
      "placeholder": "Monday"
    },
    {
      "attribute_ID": "tuesHrs",
      "fieldName": "tuesHrs",
      "label": "Tues",
      "type": "input",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please enter hours for Tuesday",
      "isAvailable": "Y",
      "placeholder": "Tuesday"
    },
    {
      "attribute_ID": "wedHrs",
      "fieldName": "wedHrs",
      "label": "Wed",
      "type": "input",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please enter hours for Wednesday",
      "isAvailable": "Y",
      "placeholder": "Wednesday"
    },
    {
      "attribute_ID": "thuHrs",
      "fieldName": "thuHrs",
      "label": "Thurs",
      "type": "input",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please enter hours for Thursday",
      "isAvailable": "Y",
      "placeholder": "Thursday"
    },
    {
      "attribute_ID": "friHrs",
      "fieldName": "friHrs",
      "label": "Fri",
      "type": "input",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please enter hours for Friday",
      "isAvailable": "Y",
      "placeholder": "Friday"
    },
    {
      "attribute_ID": "satHrs",
      "fieldName": "satHrs",
      "label": "Sat",
      "type": "input",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please enter hours for Saturday",
      "isAvailable": "Y",
      "placeholder": "Saturday"
    },
    {
      "attribute_ID": "serviceAdminLkp",
      "fieldName": "serviceAdminLkp",
      "label": "Service Administration",
      "type": "select",
      "mandatory": "n",
      "validator": null,
      "tooltip": "Please select the service administration.",
      "isAvailable": "n"
    },
    {
      "attribute_ID": "serviceDescription",
      "fieldName": "serviceDescription",
      "label": "Service Description",
      "type": "select",
      "mandatory": "Y",
      "validator": null,
      "tooltip": "Please enter Service Description",
      "isAvailable": "Y"
    },
    {
      "attribute_ID": "units",
      "fieldName": "units",
      "label": "Authorized Dollars",
      "type": "input",
      "mandatory": "Y",
      "validator": null,
      "tooltip": "Units",
      "isAvailable": "Y",
      "placeholder": "0"
    },
    {
      "attribute_ID": "unittypeLkp",
      "fieldName": "unittypeLkp",
      "label": "Unit Type",
      "type": "select",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please enter Unit Type",
      "isAvailable": "N"
    },
    {
      "attribute_ID": "startDate",
      "fieldName": "startDate",
      "label": "Auth Start Date",
      "type": "input",
      "mandatory": "Y",
      "validator": null,
      "placeholder": "MM/DD/YYYY",
      "tooltip": "Please enter Auth Start Date",
      "isAvailable": "Y"
    },
    {
      "attribute_ID": "endDate",
      "fieldName": "endDate",
      "label": "Auth End Date",
      "type": "input",
      "mandatory": "Y",
      "validator": null,
      "placeholder": "MM/DD/YYYY",
      "tooltip": "Please enter Auth End Date",
      "isAvailable": "Y"
    },
    {
      "attribute_ID": "orgName",
      "fieldName": "orgName",
      "label": "Regional Center",
      "type": "input",
      "mandatory": "Y",
      "validator": null,
      "tooltip": "Regional Center",
      "isAvailable": "Y"
    },
    {
      "attribute_ID": "categoryLkp",
      "fieldName": "categoryLkp",
      "label": "Auth Type",
      "type": "select",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Auth Type",
      "isAvailable": "N",
      "placeholder": "Select Auth Type"
    },
    {
      "attribute_ID": "serviceCoordinator",
      "fieldName": "serviceCoordinator",
      "label": "Service Coordinator",
      "type": "input",
      "mandatory": "Y",
      "validator": null,
      "tooltip": "Service Coordinator",
      "isAvailable": "Y"
    },
    {
      "attribute_ID": "providerPPLId",
      "fieldName": "providerPPLId",
      "label": "Provider PPL ID",
      "type": "input",
      "mandatory": "n",
      "validator": null,
      "tooltip": "Provider PPL ID",
      "isAvailable": "Y"
    },
    {
      "attribute_ID": "source",
      "fieldName": "source",
      "label": "Auth Source",
      "type": "select",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please select Auth Source",
      "isAvailable": "Y"
    },
    {
      "attribute_ID": "statusLkp",
      "fieldName": "statusLkp",
      "label": "Auth Status",
      "type": "select",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please select Auth Status",
      "isAvailable": "Y"
    },
    {
      "attribute_ID": "sourceDetail",
      "fieldName": "sourceDetail",
      "label": "Source Detail",
      "type": "select",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please select Auth Status",
      "isAvailable": "Y"
    },
    {
      "attribute_ID": "decisionComments",
      "fieldName": "decisionComments",
      "label": "Decision Comments",
      "type": "select",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please select Auth Status",
      "isAvailable": "Y"
    },
    {
      "attribute_ID": "decisionBy",
      "fieldName": "decisionBy",
      "label": "Decision By",
      "type": "select",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please select Auth Status",
      "isAvailable": "Y"
    },
    {
      "attribute_ID": "comments",
      "fieldName": "comments",
      "label": "Comments",
      "type": "select",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please enter Comments",
      "isAvailable": "Y"
    }
  ],
  "validations": [
    {
      "whatToCheck": "atLeastXEntered",
      "clientOrServer": "C",
      "attributes": [
        {
          "validatorid": 1,
          "attribute_ID": [
            "clientAuth"
          ],
          "functionParams": {
            "ErrMsg": "Please enter the client authorization number."
          }
        },
        {
          "validatorid": 2,
          "attribute_ID": [
            "serviceCode"
          ],
          "functionParams": {
            "ErrMsg": "Please select a service code."
          }
        },
        {
          "validatorid": 4,
          "attribute_ID": [
            "startDate"
          ],
          "functionParams": {
            "ErrMsg": "Please select a start date."
          }
        },
        {
          "validatorid": 5,
          "attribute_ID": [
            "endDate"
          ],
          "functionParams": {
            "ErrMsg": "Please select an end date."
          }
        },
        {
          "validatorid": 6,
          "attribute_ID": [
            "orgName"
          ],
          "functionParams": {
            "ErrMsg": "Please select a Regional Center."
          }
        },
        {
          "validatorid": 8,
          "attribute_ID": [
            "serviceCoordinator"
          ],
          "functionParams": {
            "ErrMsg": "Please enter a Service Coordinator."
          }
        },
        {
          "validatorid": 9,
          "attribute_ID": [
            "serviceDescription"
          ],
          "functionParams": {
            "ErrMsg": "Please enter a Service Description."
          }
        },
        {
          "validatorid": 10,
          "attribute_ID": [
            "units"
          ],
          "functionParams": {
            "ErrMsg": "Please enter Authorized Dollars."
          }
        }
      ]
    },
    {
      "whatToCheck": "checkFieldValue",
      "clientOrServer": "C",
      "attributes": [
        {
          "validatorid": 1,
          "attribute_ID": [
            "medicaidId"
          ],
          "functionParams": {
            "isNullAllowed": "N",
            "Format": "^\\d{7}$",
            "ErrMsg": "Please enter a valid UCI ID in the format of seven numbers"
          }
        }
      ]
    },
    {
      "whatToCheck": "conditionalCheck",
      "clientOrServer": "C",
      "attributes": []
    },
    {
      "whatToCheck": "customValidator",
      "clientOrServer": "C",
      "attributes": []
    }
  ],
  "actions": [
    {
      "Name": "Previous",
      "Validate": null
    },
    {
      "Name": "Submit",
      "Validate": [
        {
          "checkType": "atLeastXEntered",
          "validatorid": [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8
          ]
        },
        {
          "checkType": "checkFieldValue",
          "validatorid": []
        },
        {
          "checkType": "conditionalCheck",
          "validatorid": []
        },
        {
          "checkType": "customValidator",
          "validatorid": []
        }
      ]
    }
  ],
  "additionalDetails": {
    "sectionId": "authorizations",
    "header": "Authorizations",
    "available_actions": null,
    "attributes": [
      {
        "attribute_ID": "consumerPlanId",
        "fieldName": "consumerPlanId",
        "label": "Authorization Unique ID",
        "type": "select",
        "mandatory": "N",
        "validator": null,
        "tooltip": "Please enter PPl Id",
        "isAvailable": "Y"
      },
      {
        "attribute_ID": "isDeleted",
        "fieldName": "isDeleted",
        "label": "Is Deactivated",
        "type": "input",
        "mandatory": "Y",
        "validator": null,
        "tooltip": "Please enter Client Auth Number",
        "isAvailable": "Y"
      },
      {
        "attribute_ID": "comments",
        "fieldName": "comments",
        "label": "Comments",
        "type": "input",
        "mandatory": "Y",
        "validator": null,
        "tooltip": "Please select a service code.",
        "isAvailable": "Y"
      },
      {
        "attribute_ID": "medicaidId",
        "fieldName": "medicaidId",
        "label": "UCI ID",
        "type": "input",
        "mandatory": "N",
        "validator": null,
        "tooltip": "Please enter your UCI Id #",
        "isAvailable": "Y",
        "placeholder": "UCI ID"
      }
    ],
    "validations": [
      {
        "whatToCheck": "atLeastXEntered",
        "clientOrServer": "C",
        "attributes": []
      },
      {
        "whatToCheck": "checkFieldValue",
        "clientOrServer": "C",
        "attributes": []
      },
      {
        "whatToCheck": "conditionalCheck",
        "clientOrServer": "C",
        "attributes": []
      },
      {
        "whatToCheck": "customValidator",
        "clientOrServer": "C",
        "attributes": []
      }
    ],
    "actions": [
      {
        "Name": "Previous",
        "Validate": null
      },
      {
        "Name": "Submit",
        "Validate": [
          {
            "checkType": "atLeastXEntered",
            "validatorid": []
          },
          {
            "checkType": "checkFieldValue",
            "validatorid": []
          },
          {
            "checkType": "conditionalCheck",
            "validatorid": []
          },
          {
            "checkType": "customValidator",
            "validatorid": []
          }
        ]
      }
    ]
  }
}